import { Menu, X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { NotificationMenu } from '@/features/notification'
import { useAuthStore } from '@/stores/auth.store'

import { UserDropdown } from './Sidebar'
import { WorkspaceSwitcher } from './WorkspaceSwitcher'

interface MobileHeaderProps {
  isMobileOpen: boolean
  onToggleMobileMenu: () => void
  onOpenCreateModal?: () => void
}

export function MobileHeader({
  isMobileOpen,
  onToggleMobileMenu,
  onOpenCreateModal,
}: MobileHeaderProps) {
  const userEmail = useAuthStore(
    (state) => state.email
  )

  const userInitial =
    userEmail?.charAt(0).toUpperCase() || 'U'

  return (
    <header className="sticky top-0 z-40 flex h-16 min-h-16 max-h-16 w-full shrink-0 items-center justify-between border-b border-neutral-200 bg-white px-3 lg:hidden">
      {/* Left Section */}
      <div className="flex min-w-0 items-center gap-2">
        {/* Mobile Menu */}
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleMobileMenu}
          className="h-9 w-9 shrink-0 text-neutral-700 hover:bg-neutral-100"
          aria-label={
            isMobileOpen
              ? 'Close menu'
              : 'Open menu'
          }
        >
          {isMobileOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>

        {/* Workspace Switcher */}
        <div className="min-w-0 w-48 sm:w-56">
          <WorkspaceSwitcher
            onOpenCreateModal={onOpenCreateModal}
          />
        </div>
      </div>

      {/* Right Section */}
      <div className="flex shrink-0 items-center gap-1">
        {/* Notifications */}
        <NotificationMenu
          showLabel={false}
          navigateToNotifications
          triggerClassName="h-9 w-9 justify-center rounded-lg px-0"
        />

        {/* User */}
        <UserDropdown
          align="end"
          trigger={
            <Button
              variant="ghost"
              className="h-9 w-9 rounded-full p-0 hover:bg-neutral-100"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-xs font-semibold text-primary-700">
                {userInitial}
              </div>
            </Button>
          }
        />
      </div>
    </header>
  )
}
